import(/* webpackMode: "eager" */ "/vercel/path0/components/Newsletter.js")